import React from 'react';
import { useNavigate } from 'react-router-dom';
import { VideoIcon } from 'lucide-react';
export function Home() {
  const navigate = useNavigate();
  return <div className="min-h-screen flex flex-col items-center justify-center p-6 text-white" data-id="element-85">
      <div className="max-w-4xl w-full space-y-8" data-id="element-86">
        <div className="text-center space-y-4" data-id="element-87">
          <h1 className="text-5xl md:text-6xl font-bold" data-id="element-88">Studio Centrum</h1>
          <p className="text-xl md:text-2xl opacity-90" data-id="element-89">
            Bierz udział w dyskusji z dziennikarzami, ekspertami i politykami w
            Studio Centrum
          </p>
        </div>
        <div className="flex justify-center mt-12" data-id="element-90">
          <div className="bg-white/10 backdrop-blur-sm rounded-2xl p-8 space-y-4 hover:bg-white/20 transition-all max-w-2xl w-full" data-id="element-91">
            <VideoIcon className="w-12 h-12" data-id="element-92" />
            <h3 className="text-2xl font-semibold" data-id="element-93">Nagraj video</h3>
            <p className="opacity-90 text-lg" data-id="element-94">
              Zadaj pytanie ekspertowi / politykowi i wpływaj na nasz program!
              Budujemy Studio Centrum razem z Wami.
            </p>
          </div>
        </div>
        <div className="flex flex-col sm:flex-row gap-4 justify-center mt-12" data-id="element-95">
          <button onClick={() => navigate('/create')} className="bg-white text-rose-500 px-8 py-4 rounded-full text-lg font-semibold hover:bg-opacity-90 transition-all shadow-lg" data-id="element-96">
            Nagraj Video
          </button>
          <button onClick={() => navigate('/dashboard')} className="bg-white/20 backdrop-blur-sm text-white px-8 py-4 rounded-full text-lg font-semibold hover:bg-white/30 transition-all" data-id="element-97">
            Twój Panel
          </button>
        </div>
      </div>
    </div>;
}